const OpenNewPage = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path
      fillRule='nonzero'
      d='M20.5 4.56l-7.97 7.97a.75.75 0 0 1-1.06-1.06l7.97-7.97h-6.69a.75.75 0 1 1 0-1.5h8.5a.75.75 0 0 1 .75.75v8.5a.75.75 0 1 1-1.5 0V4.56zm0 10.44a.75.75 0 1 1 1.5 0v6.25a.75.75 0 0 1-.75.75H2.75a.75.75 0 0 1-.75-.75V2.75A.75.75 0 0 1 2.75 2H9a.75.75 0 0 1 0 1.5H3.5v17h17V15z'
    />
  </svg>
);

export default OpenNewPage;
